import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import * as reviewApi from "../../services/reviews";
import Button from "../../components/Button";
import "../../styles/reviews.css";

function AddReviewPage() {
  const history = useHistory();
  const [form, setForm] = useState({ name: "", location: "", description: "", picture: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (!form.name.trim()) errors.name = "Name is required";
    if (!form.location.trim()) errors.location = "Location is required";
    if (!form.description.trim()) errors.description = "Description is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length) {
      setError(Object.values(errors).join(". "));
      return;
    }
    setLoading(true);
    setError("");
    try {
      await reviewApi.createReview(form);
      history.push("/reviews");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to add review");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <div className="container" style={{ maxWidth: 600 }}>
        <Button title="Back" typeBtn="secondary" onPress={() => history.push("/reviews")} />
        <h2 className="mt-3 mb-3">Add Review</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-2">
            <label>Name</label>
            <input name="name" className="form-control" value={form.name} onChange={handleChange} required />
          </div>
          <div className="form-group mb-2">
            <label>Location</label>
            <input name="location" className="form-control" value={form.location} onChange={handleChange} required />
          </div>
          <div className="form-group mb-2">
            <label>Description</label>
            <textarea
              name="description"
              className="form-control"
              value={form.description}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group mb-3">
            <label>Picture URL</label>
            <input name="picture" className="form-control" value={form.picture} onChange={handleChange} />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <Button title={loading ? "Saving..." : "Add Review"} type="submit" typeBtn="primary" disabled={loading} />
        </form>
      </div>
    </div>
  );
}

export default AddReviewPage;
